import { NgModule, CUSTOM_ELEMENTS_SCHEMA, provideAppInitializer, inject } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorInterceptor } from './_infrastructure/interceptors/error.interceptor';
import { SuccessInterceptor } from './_infrastructure/interceptors/success.interceptor';
import { JwtInterceptor } from './_infrastructure/interceptors/jwt.interceptor';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { CommonModule } from '@angular/common';
import { SharedModule } from './_shared';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LOCALE_ID } from '@angular/core';
import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { DomainService } from './_infrastructure/services/domain/domain.service';
import { ExternalAuthService } from './_infrastructure/services/auth/external-auth/external-auth.service';

import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { OrganizationChartModule } from 'primeng/organizationchart';

export function initApp() {
  const domainService = inject(DomainService);
  return domainService.init();
}

export function initExternal() {
  const externalAuth = inject(ExternalAuthService);
  void externalAuth.loadToken();
}

registerLocaleData(localePt);
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    LayoutModule,
    CarouselModule.forRoot(),
    SharedModule,
    FontAwesomeModule,
    OrganizationChartModule
  ],
  providers: [
    provideAppInitializer(initApp),
    provideAppInitializer(initExternal),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    provideHttpClient(withInterceptorsFromDi()),
    JwtHelperService,
    provideAnimationsAsync(),
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS, },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SuccessInterceptor, multi: true },
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
            darkModeSelector: '.my-app-dark'
        }
      }
    })
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
